/**
 * Created by marenkoehler on 28.04.14.
 */
import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';
    OndigoNS.InitLightbox = function (element, index, isLightboxFCE, lightboxId) {
        this.$lightboxStarter = $('.openLightbox[data-lightboxid="' + lightboxId + '"]');
        this.lightboxFCEIndex = index;
        this.lightboxImageArrayLength = 0;
        this.hasTouchscreen = OndigoNS.Utils.hasTouchscreen();

        this.$window = $(window);
        this.$body = $('body');
        this.$document = $(document);
        this.scrollPosition = 0;

        this.activeIndex = 0;
        this.arrayImageIndex = 0;

        this.smartphoneImage = null;
        this.desktopImage = null;
        this.imageDescription = null;
        this.imageId = null;
        this.videoId = null;
        this.$videoItem = null;

        this.navElementHovered = false;
        this.navElementVisible = true;
        this.navElementHidden = false;
        this.arrowNextVisible = true;
        this.arrowPrevVisible = false;
        this.mouseMoveTimer = null;

        this.$lightboxWrapper = null;
        this.lightboxWrapperTemplate = '<div class="lightboxWrapper">' +
            '<div class="overlay"></div>' +
            '<div class="lightbox">' +
            '<div class="onIconCloseCircle noswipe"></div>' +
            '<div class="lightboxImageWrapper"></div>' +
            '<div class="onIconArrowSimpleRight noswipe" style="display: none"></div>' +
            '<div class="onIconArrowSimpleLeft noswipe" style="display: none"></div>' +
            '<div class="imageDescriptionWrapper noswipe">' +
            '<div class="arrowWrapper opened">' +
            '<div class="onIconArrowUp"></div>' +
            '</div>' +
            '<div class="imageDescription">' +
            '<div class="textWrapper"></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        // slide animation
        this.isLocked = false;
        this.slideAnimatedWithSwipe = false;
        this.swipeDistance = 100;
        this.slideLeftPosition = null;
        this.initialized = false;

        this.init();
    };

    OndigoNS.InitLightbox.prototype = {
        init : function () {
            var _instance = this;

            this.$lightboxStarter.on('click openLightbox', function () {
                if (!_instance.initialized) {
                    _instance.setListeners();
                    _instance.initialized = true;
                }
                _instance.openLightbox($(this));
            });
        },
        setListeners : function () {
            var _instance = this;

            if (this.hasTouchscreen) {
                // needed for mobile swipe (swipe won't work on Iphone 5 >)
                this.$body.bind('touchstart', function () {
                    setTimeout(function() {}, 100);
                });

                this.$window.on('orientationchange', function () {
                    setTimeout(function () {
                        if(_instance.$lightboxWrapper !== undefined) {
                            _instance.updateLightboxDimensions();
                            _instance.setImageSrc(_instance.activeIndex);
                        }
                    }, 100);
                });
            }
            else {
                this.$window.on('resize', function () {
                    setTimeout(function () {
                        if(_instance.$lightboxWrapper !== undefined) {
                            _instance.updateLightboxDimensions();
                            _instance.setImageSrc(_instance.activeIndex);
                        }
                    }, 100);
                });
            }
        },
        openLightbox : function (starter) {
            this.scrollPosition = this.$document.scrollTop();

            if(this.$lightboxWrapper === null) {
                this.$lightboxWrapper = $(this.lightboxWrapperTemplate);
                this.$body.append(this.$lightboxWrapper);
                this.$lightboxWrapper.attr('data-lightboxid', starter.data('lightboxid'));
                this.initNavigation();
            } else {
                this.$lightboxWrapper.show();
            }

            this.activeIndex = starter.data('starterindex');

            if($('.lightboxImage', this.$lightboxWrapper).length <= 0) {
                for(var i = 0; i < OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent.length; i++) {
                    $('.lightboxImageWrapper', this.$lightboxWrapper).append($(this.setLightboxImageByIndex(i)));
                }
            }

            this.checkIfSrcNeedToBeLoaded(this.activeIndex-1);
            this.checkIfSrcNeedToBeLoaded(this.activeIndex);

            this.setImageDescription(this.activeIndex);

            this.$videoItem = $('.videoContent', this.$lightboxWrapper).videojsCustom();
            if (this.activeIndex == 1) {
                window.setTimeout(function() {
                    OndigoNS.VideoJS.startVideo();
                }, 1000);
            }

            this.getLightboxImageByIndex(this.activeIndex);

            if (this.hasTouchscreen) {
                $('.lightboxImageWrapper', this.$lightboxWrapper).css({
                    '-moz-transform' : 'translateX(' + -(100 * this.activeIndex) + '%)',
                    '-webkit-transform' : 'translateX(' + -(100 * this.activeIndex) + '%)',
                    '-o-transform' : 'translateX(' + -(100 * this.activeIndex) + '%)',
                    '-ms-transform' : 'translateX(' + -(100 * this.activeIndex) + '%)',
                    'transform' : 'translateX(' + -(100 * this.activeIndex) + '%)',
                });
            } else {
                $('.lightboxImageWrapper', this.$lightboxWrapper).css({left: -(100 * this.activeIndex) + '%'});
            }

            // load next and previous images if needed
            if(this.activeIndex > 0) {
                $('.onIconArrowSimpleLeft', this.$lightboxWrapper).show();
                if(OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent.length > 2) {
                    $('.onIconArrowSimpleRight', this.$lightboxWrapper).show();
                } else {
                    $('.onIconArrowSimpleRight', this.$lightboxWrapper).hide();
                }
                if(this.activeIndex === OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent.length - 1) {
                    $('.onIconArrowSimpleRight', this.$lightboxWrapper).hide();
                }
            } else {
                $('.onIconArrowSimpleLeft', this.$lightboxWrapper).hide();
                if(OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent.length > 1) {
                    $('.onIconArrowSimpleRight', this.$lightboxWrapper).show();
                }
            }

            if(this.$lightboxStarter.parents('.sliderLightbox').length) {
                this.$lightboxStarter.parents('.sliderLightboxOverflow').swipe('disable');
            }

            this.updateLightboxDimensions();

            if (this.hasTouchscreen) {
                document.addEventListener('touchmove', this.preventDefault, false);

                $('.lightboxImageWrapper', this.$lightboxWrapper).swipe('enable');
                $('.lightboxImageWrapper', this.$lightboxWrapper).on('touchstart touchend touchleave touchmove', function () {
                    return false;
                });
            }

            this.$body.css({
                overflow: 'hidden'
            });
        },
        // get images from fluid
        getLightboxImageByIndex : function (index) {
            if (OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[index].videoID) {
                this.videoId = OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[index].videoID;
            }
            else {
                this.lightboxImageArrayLength = OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent.length;
                this.smartphoneImage = OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[index].onImageSmartphone;
                this.imageDescription = OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[index].imageDescription;
                this.desktopImage = OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[index].onImageDesktop;
                this.imageId = 'l' + this.lightboxFCEIndex + '-' + OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[index].imageUid;
                this.videoId = null;
            }
        },
        // set htnl for lightbox-images
        setLightboxImageByIndex : function (index) {
            this.getLightboxImageByIndex(index);
            if (this.videoId) {
                return '<div class="videoContent" data-video-src="https://www.youtube.com/watch?v=' + this.videoId + '" data-video-id="999" data-init="1" data-video-network="youtube" data-google-analytics="0" data-playlist="0">' +
                    '<div class="videoWrapper"><video id="v999" class="video-js vjs-default-skin vjs-big-play-centered" preload="none" data-type="videojs"></video>' +
                    '</div></div>';
            }
            else {

                return '<div class="lightboxImage">' +
                    this.smartphoneImage +
                    this.desktopImage +
                    '</div>';
            }
        },

        goNext : function () {
            if(this.isLocked) {
                return;
            }
            this.showNextImage();
        },
        goPrev : function () {
            if(this.isLocked) {
                return;
            }
            this.showPrevImage();
        },
        showNextImage : function () {
            if(!this.$lightboxStarter.parents('.sliderLightbox').length) {
                this.preloadNextImage();
            }

            var nextIndex = this.activeIndex + 1,
                max;

            if (this.videoId) {
                max = this.lightboxImageArrayLength;
            }
            else {
                max = this.lightboxImageArrayLength - 1;
            }
            this.checkIfSrcNeedToBeLoaded(nextIndex);

            if(this.activeIndex < max) {
                this.activeIndex++;
                this.useHtml5OnSmartphone(-(100 * this.activeIndex), 1);
                this.setImageDescription(this.activeIndex);
                this.arrayImageIndex++;
            } else {
                this.useHtml5OnSmartphone(-(100 * this.activeIndex + 10), 1);
                this.useHtml5OnSmartphone(-(100 * this.activeIndex), 1);
            }

            this.handleLightboxNavigationArrow(this.navElementVisible);
        },
        showPrevImage : function () {
            var prevIndex = this.activeIndex - 1;
            this.checkIfSrcNeedToBeLoaded(prevIndex);
            this.checkIfSrcNeedToBeLoaded(prevIndex-1);

            if(this.activeIndex > 0) {
                this.activeIndex--;
                this.useHtml5OnSmartphone(-(100 * this.activeIndex), 1);
                this.setImageDescription(this.activeIndex);
                this.arrayImageIndex--;
            } else {
                this.useHtml5OnSmartphone((10 * this.activeIndex), 1);
                this.useHtml5OnSmartphone((0), 1);
            }

            this.handleLightboxNavigationArrow(this.navElementVisible);
        },
        swipeSlide : function (event, phase, direction, distance) {
            var distancePercent = distance / OndigoNS.Utils.getWindowInnerWidth() * 100;
            if(direction === 'left' && this.slideAnimatedWithSwipe === false) {
                if(distance < this.swipeDistance) {
                    if(phase === 'move') {
                        this.transformTransition(-(this.slideLeftPosition + distancePercent), 0);
                    }
                    if(phase === 'end') {
                        this.transformTransition(-(this.slideLeftPosition), 1);
                    }
                } else {
                    this.slideAnimatedWithSwipe = true;
                    this.goNext();
                }
            } else if (direction === 'right' && this.slideAnimatedWithSwipe === false) {
                if(distance < this.swipeDistance) {
                    if(phase === 'move') {
                        this.transformTransition(-(this.slideLeftPosition - distancePercent), 0);
                    }
                    if(phase === 'end') {
                        this.transformTransition(-(this.slideLeftPosition), 1);
                    }
                } else {
                    this.slideAnimatedWithSwipe = true;
                    this.goPrev();
                }
            } else if (direction === 'up' && !$('.arrowWrapper', this.$lightboxWrapper).hasClass('opened')) {
                if(distance > this.swipeDistance) {
                    this.showDescription($('.arrowWrapper', this.$lightboxWrapper));
                }
            } else if (direction === 'down' && $('.arrowWrapper', this.$lightboxWrapper).hasClass('opened')) {
                if(distance > this.swipeDistance) {
                    this.hideDescription($('.arrowWrapper', this.$lightboxWrapper));
                }
            }
            this.slideLeftPosition = this.activeIndex * 100;

            if (phase === 'end') {
                this.slideAnimatedWithSwipe = false;
            }
        },

        preloadNextImage : function () {
            var nextIndex = this.arrayImageIndex;
            if(nextIndex < this.lightboxImageArrayLength) {
                this.getLightboxImageByIndex(nextIndex);
                if($('[data-uid="' + this.imageId + '"]').length < 1) {
                    $('.lightboxImageWrapper', this.$lightboxWrapper).append($(this.setLightboxImageByIndex(nextIndex)));
                }
            }
        },
        checkIfSrcNeedToBeLoaded : function (index) {
            var src,
                $img;

            if(OndigoNS.Utils.getWindowInnerWidth() > OndigoNS.breakpointSliderImageCondition) {
                $img = $('.lightboxImage img.desktop', this.$lightboxWrapper).eq(index);
            } else {
                $img = $('.lightboxImage img.smartphone', this.$lightboxWrapper).eq(index);
            }
            src = window.devicePixelRatio > 1 ? $img.data('retina') : $img.data('image-source');
            if ($img.attr('src') !== src) {
                $img.addClass('loading');
                this.setImageSrc(index);
            }
        },
        setImageSrc : function (index) {
            var src,
                $img;

            if(OndigoNS.Utils.getWindowInnerWidth() > OndigoNS.breakpointSliderImageCondition) {
                $img = $('.lightboxImage img.desktop', this.$lightboxWrapper).eq(index);
            } else {
                $img = $('.lightboxImage img.smartphone', this.$lightboxWrapper).eq(index);
            }
            src = window.devicePixelRatio > 1 ? $img.data('retina') : $img.data('image-source');
            this.loadImage($img, src);
        },

        loadImage : function ($img, src) {
            if($img.attr('src') === '' || $img.attr('src') !== src) {
                var $image = $('<img src="' + src + '">'),
                    width = $img.attr('width') > OndigoNS.Utils.getWindowInnerWidth() ? OndigoNS.Utils.getWindowInnerWidth() : $img.attr('width');
                $img.addClass('loading').css('height', (width / $img.data('resolution-factor')) + 'px').css('width', width);
                $image.on('load', function () {
                    $img.removeAttr('autoload')
                        .removeAttr('height')
                        .removeClass('loading')
                        .attr('style', '')
                        .hide()
                        .attr('src', src)
                        .fadeIn('fast', function() {
                            $img.removeAttr('style');
                        });
                });
            }
        },

        setImageDescription : function (activeIndex) {
            this.imageDescription = OndigoNS.LightboxFCE[this.lightboxFCEIndex].lightboxContent[activeIndex].imageDescription;

            if(this.imageDescription.length) {
                $('.imageDescriptionWrapper', this.$lightboxWrapper).removeClass('hidden');
            } else {
                $('.imageDescriptionWrapper', this.$lightboxWrapper).addClass('hidden');
            }

            if(this.imageDescription.length) {
                $('.textWrapper', this.$lightboxWrapper).html(this.imageDescription);
            }
        },

        // handle Navigation
        initNavigation : function () {
            var _instance = this;

            $('.onIconCloseCircle', this.$lightboxWrapper).on('click', function () {
                _instance.closeLightbox();
                return false;
            });
            $('.onIconArrowSimpleRight', this.$lightboxWrapper).on('click', function () {
                _instance.goNext();
                return false;
            });
            $('.onIconArrowSimpleLeft', this.$lightboxWrapper).on('click', function () {
                _instance.goPrev();
                return false;
            });
            $('.arrowWrapper', this.$lightboxWrapper).on('click', function () {
                if($(this).hasClass('opened')) {
                    _instance.hideDescription($(this));
                } else {
                    _instance.showDescription($(this));
                }
                return false;
            });

            this.$document.keydown(function (e) {
                _instance.keyPressed = true;
                if (e.keyCode === 39) {
                    _instance.goNext();
                }
                if (e.keyCode === 37) {
                    _instance.goPrev();
                }
                if (e.keyCode === 27) {
                    _instance.closeLightbox();
                }
            }).keyup(function () {
                _instance.keyPressed = false;
            });

            if (this.hasTouchscreen) {
                $('.lightboxImageWrapper', this.$lightboxWrapper).swipe({
                    swipeStatus: $.proxy(_instance.swipeSlide, this),
                    threshold: this.swipeDistance,
                    maxTimeThreshold: 2500,
                    fingers: 'all',
                    allowPageScroll: 'none',
                    click: function (event, target) {
                        $(target).click();
                    }
                });
            }
        },
        closeLightbox : function () {
            this.$body.css({
                overflow: 'auto'
            });
            if (this.hasTouchscreen) {
                $('.lightboxImageWrapper', this.$lightboxWrapper).swipe('disable');
                this.$lightboxWrapper.off('click');
                document.removeEventListener('touchmove', this.preventDefault, false);
            }
            if(this.$lightboxStarter.parents('.sliderLightbox').length) {
                this.$lightboxStarter.parents('.sliderLightboxOverflow').swipe('enable');
            }

            OndigoNS.VideoJS.pauseVideo();

            this.$lightboxWrapper.hide().prop('disabled', true);
            this.$document.scrollTop(this.scrollPosition);
            this.scrollPosition = 0;
        },
        handleNavigationVisibility : function () {
            var _instance = this;
            if(!this.hasTouchscreen) {
                $('.iconArrow, .onIconArrowSimpleLeft, .onIconCloseCircle', this.$lightboxWrapper).mouseover(function () {
                    _instance.navElementHovered = true;
                }).mouseout(function () {
                    _instance.navElementHovered = false;
                });

                this.$lightboxWrapper.mousemove(function () {
                    var scope = _instance;
                    if(!_instance.navElementHidden) {
                        _instance.navElementHidden = false;
                        _instance.navElementVisible = true;
                        clearTimeout(_instance.mouseMoveTimer);
                        _instance.showNavigation();
                        if(!_instance.navElementHovered) {
                            _instance.mouseMoveTimer = setTimeout(function () {
                                var innerScope = scope;
                                scope.hideNavigation();
                                _instance.navElementVisible = false;
                                scope.navElementHidden = true;
                                setTimeout(function () {
                                    innerScope.navElementHidden = false;
                                }, 500);
                            }, 3000);
                        }
                    }
                    _instance.handleLightboxNavigationArrow(_instance.navElementVisible);
                });

                if(this.navElementHidden) {
                    setTimeout(function(){
                        if(_instance.navElementHovered === false) {
                            _instance.hideNavigation();
                        }
                    }, 3000);
                }
            } else {
                this.$lightboxWrapper.on('click', function (e) {
                    e.stopPropagation();
                    if(_instance.navElementVisible) {
                        _instance.hideNavigation();
                        _instance.navElementVisible = false;
                    } else {
                        _instance.showNavigation();
                        _instance.navElementVisible = true;
                    }
                });
            }
        },
        hideNavigation : function () {
            $('.onIconArrowSimpleRight, .onIconArrowSimpleLeft, .onIconCloseCircle', this.$lightboxWrapper).fadeOut();
            if(!$('.arrowWrapper', this.$lightboxWrapper).hasClass('opened')) {
                $('.arrowWrapper', this.$lightboxWrapper).fadeOut();
            }
        },
        showNavigation : function () {
            if(this.arrowNextVisible) {
                $('.onIconArrowSimpleRight', this.$lightboxWrapper).fadeIn();
            }
            if(this.arrowPrevVisible) {
                $('.onIconArrowSimpleLeft', this.$lightboxWrapper).fadeIn();
            }
            $('.onIconCloseCircle', this.$lightboxWrapper).fadeIn();
        },
        handleLightboxNavigationArrow : function (isVisible) {
            var $onIconArrowSimpleLeft = $('.onIconArrowSimpleLeft', this.$lightboxWrapper),
                $onIconArrowSimpleRight = $('.onIconArrowSimpleRight', this.$lightboxWrapper),
                max;

            if (this.videoId) {
                max = this.lightboxImageArrayLength - 1;
            }
            else {
                max = this.lightboxImageArrayLength - 1;
            }

            if(isVisible) {
                if(this.activeIndex === 0) {
                    $onIconArrowSimpleLeft.fadeOut();
                    this.arrowPrevVisible = false;
                } else {
                    $onIconArrowSimpleLeft.fadeIn();
                    this.arrowPrevVisible = true;
                }

                if (this.activeIndex === max) {
                    $onIconArrowSimpleRight.fadeOut();
                    this.arrowNextVisible = false;
                } else {
                    $onIconArrowSimpleRight.fadeIn();
                    this.arrowNextVisible = true;
                }
            }
        },

        // handle image-description:
        showDescription : function ($this) {
            $('.imageDescription', this.$lightboxWrapper).slideDown(function () {
                $this.addClass('opened');
            });
        },
        hideDescription : function ($this) {
            $('.imageDescription', this.$lightboxWrapper).slideUp(function () {
                $this.removeClass('opened');
            });
        },
        setDescriptionDimension : function () {
            var maxHeight = OndigoNS.Utils.getWindowInnerHeight(),
                $imageDescription = $('.imageDescription', this.$lightboxWrapper),
                $imageDescriptionWrapper = $('.imageDescriptionWrapper', this.$lightboxWrapper);

            $imageDescriptionWrapper.css('width', OndigoNS.Utils.getWindowInnerWidth());

            if($imageDescription.outerHeight() > maxHeight - 78) {
                $imageDescription.css('overflow-y', 'scroll');
            } else {
                $imageDescription.css('overflow-y', 'visible');
            }
            $imageDescription.css('max-height', maxHeight - 78);
        },


        // handle animation (touch or no-touch)
        useHtml5OnSmartphone : function (distance, transition) {
            var _instance = this;
            if (this.hasTouchscreen) {
                this.isLocked = true;
                this.transformTransition(distance, transition);
                setTimeout(function () {
                    _instance.isLocked = false;
                }, transition * 1000);
            } else {
                this.isLocked = true;
                $('.lightboxImageWrapper', this.$lightboxWrapper).stop().animate({left: distance + '%'}, 400, function () {
                    _instance.isLocked = false;
                });
            }
        },
        transformTransition : function (distance, transition) {
            $('.lightboxImageWrapper', this.$lightboxWrapper).css({
                '-moz-transform' : 'translateX(' + distance + '%)',
                '-moz-transition' : transition + 's',
                '-webkit-transform' : 'translateX(' + distance + '%)',
                '-webkit-transition' : transition + 's',
                '-o-transform' : 'translateX(' + distance + '%)',
                '-o-transition': transition + 's',
                '-ms-transform' : 'translateX(' + distance + '%)',
                '-ms-transition' : transition + 's',
                'transform' : 'translateX(' + distance + '%)',
                'transition' : transition + 's'
            });
        },
        updateLightboxDimensions : function () {
            $('.lightboxWrapper .lightbox').css({
                width: OndigoNS.Utils.getWindowInnerWidth(),
                height: OndigoNS.Utils.getWindowInnerHeight() + 'px'
            });
        },
        preventDefault : function (e) {
            e.preventDefault();
        }
    };

    // plugin definition
    $.fn.initLightbox = function (index, isLightboxFCE, lightboxId) {
        return new OndigoNS.InitLightbox(this, index, isLightboxFCE, lightboxId);
    };
    $.fn.initLightbox.Constructor = OndigoNS.InitLightbox;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $lightboxFCEImages = $('.openLightbox'),
        dataAttributes = {},
        $starter = [];

    if ($lightboxFCEImages.length) {
        $lightboxFCEImages.each(function (index, el) {
            if (!($(el).data('lightboxid') in dataAttributes)) {
                dataAttributes[$(el).data('lightboxid')] = [];
                dataAttributes[$(el).data('lightboxid')].push($(el));
                $starter.push($(el));
            }
        });

        for(var i = 0; i < $starter.length; i++) {
            $starter[i].initLightbox(i, true, $starter[i].data('lightboxid'));
        }
    }
});